import React from "react";
import { Validator, TagBox } from "devextreme-react";

class TagField extends React.PureComponent {
  render() {
    const {
      label,
      displayExpr,
      valueExpr,
      searchEnabled,
      dataSource,
      items,
      disabled,
      onChange,
      id,
      optional,
      validation,
      ...rest
    } = this.props;
    return (
      <div className="field-newDenuncia" style={{ marginLeft: optional ? 20 : 0 }}>
        <h3><p>{label}</p></h3>
        <TagBox
          searchEnabled={searchEnabled}
          placeholder=""
          items={items}
          dataSource={dataSource}
          disabled={disabled}
          onValueChanged={onChange}
          displayExpr={displayExpr}
          valueExpr={valueExpr}
          id={id}
          {...rest}
        >
          {(validation !== false) ?
            <Validator
              validationRules={[{
                type: "required",
                message: "Este campo es requerido",
              }]}
            />
            : ""
          }
        </TagBox>
      </div >
    );
  }
}

export default TagField;
